import { render, staticRenderFns } from "./SideMenuRouterView.vue?vue&type=template&id=2ff85d7e&"
import script from "./SideMenuRouterView.vue?vue&type=script&lang=js&"
export * from "./SideMenuRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VNavigationDrawer,VSheet})
